import { Col, Container, Row } from 'react-bootstrap'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import './IndustrialProducts.css'


const IndustrialProducts = () => {
    return (
        <main className='industrialproducts'>
            <Container>
                <Row>
                    <h2>Nuestros servicios en Frío Industrial</h2>
                    <Col md={12} className='my-4'>
                        <VerticalTimeline lineColor={ '#000' }>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Temperaturas controladas</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'left'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Monitorización continua de temperaturas</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Control de humedad y monitorización</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'left'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Centros de datos</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Mantenimiento y control continuo</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'left'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Servicio técnico</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Diseño, desarrollo y puesta en marcha de soluciones a medida</p>
                            </VerticalTimelineElement>
                        </VerticalTimeline>
                    </Col>
                </Row>
            </Container>
        </main>
    )
}

export default IndustrialProducts